export const COSTING_SHEET_PAGE_SIZE=50;
export const COSTING_SHEET_FIRST_PAGE = 1;


export const MEMBER_DETAILS_PAGE_SIZE = 300/* 10 */;
export const MEMBER_DETAILS_FIRST_PAGE = 1;

export const POLICY_DOCUMENTS = "policyDocuments";
export const MEMBER_DOCUMENTS = "memberDocuments";

export const POLICY_BENEFICIARY_MEMBER = "member";
export const POLICY_BENEFICIARY_DEPENDENT = "dependent";

export const BENEFFICARY_SECTION_MEMBER = "memberInformation";
export const BENEFFICARY_SECTION_DEPENDENT = "dependentInformation";

export const BENEFFICARY_SECTION_MEMBER_DETAILS = "memberDetails";
export const BENEFFICARY_SECTION_DEPENDENT_DETAILS = "dependentDetails";

export const MEMBER_FILTERED_DETAILS = "memberFilteredDetails";
export const DEPENDENT_FILTERED_DETAILS = "dependentFilteredDetails";

export const SHOW_MEMBERS = "showMembers";
export const SHOW_MEMBER_DEPENDENTS = "showMemberDependents";
export const SHOW_DEPENDENTS = "showDependents";

export const SHOW_MEMBER_DETAILS = "showMemberDetails";

export const PRODUCT_TYPE_INDIVIDUAL = 182;

export const ENDO_CONFG_GENERAL_ENDORSEMENT=1;
export const ENDO_CONFG_EXTENSION_OF_PERIOD = 2;
export const ENDO_CONFG_ADDITION_OF_MEMBER=3;
export const ENDO_CONFG_DELETION_OF_MEMBER = 4;
export const ENDO_CONFG_CANCELLATION=5;
export const ENDO_CONFG_CHANGING_MEMBER_CATEGORY_UPGRADE = 6;
export const ENDO_CONFG_DOB_CHANGE=7;
export const ENDO_CONFG_ADDITION_OF_CATEGORY =8;
export const ENDO_CONFG_MARITAL_STATUS_CHANGE=9;
export const ENDO_CONFG_CHANGE_IN_BROKERAGE = 10;
export const ENDO_CONFG_PREMIUM_ADJUSTMENT_ADDITION=11;
export const ENDO_CONFG_CHANGING_MEMBER_CATEGORY_DOWN = 12;
export const ENDO_CONFG_CHANGE_OF_CLIENT=13;
export const ENDO_CONFG_CHANGE_IN_POLICY_PERIOD = 14;
export const ENDO_CONFG_PREMIUM_ADJUSTMENT_REFUND = 15;

export const BENEFICIARY_RESIDENT_LOCATION_MASTERS_MEMBER = "memberResidentLocationMasters";
export const BENEFICIARY_RESIDENT_LOCATION_MASTERS_DEPENDENT = "dependentResidentLocationMasters";

export const BENEFICIARY_WORK_LOCATION_MASTERS_MEMBER = "memberWorkLocationMasters";
export const BENEFICIARY_WORK_LOCATION_MASTERS_DEPENDENT = "dependentWorkLocationMasters";

export const BENEFICIARY_VISA_LOCATION_MASTERS_MEMBER = "memberVisaLocationMasters";
export const BENEFICIARY_VISA_LOCATION_MASTERS_DEPENDENT = "dependentVisaLocationMasters";
export const SHOW_DEPENDENT_DETAILS = "showDependentDetails";

export const POLICY_PAGE = "policy"
export const MEMBER_PAGE = "member"

export const IS_ZERO = 0;
export const IS_ONE = 1;
export const IMPORT_MEMBER_PAGE_SIZE = 100;
export const IMPORT_MEMBER_FIRST_PAGE = 1;
export const DOMAIN_SALUTATION_MS_COMPANY = 267;
